export default class CarouselLivestreaming {
  init() {
    this.carousel();
  }

  carousel() {
    var container = $('.livestreaming__tvstreams-container');
    var tvStreamId = $('meta[name="page"]').data('id');
    var currentTvStream = container.find('[data-tvstream-id="' + tvStreamId + '"]');
    currentTvStream.addClass('current_tvstream');

    container.slick({
      arrows: true,
      infinite: true,
      speed: 100,
      cssEase: 'easeInOut',
      slidesToShow: 10,
      slidesToScroll: 9,
      initialSlide: currentTvStream.index()
    });
  }
}
